import { type Dayjs } from "dayjs";

export function formatDates(start: Dayjs, end: Dayjs) {
  return {
    trip_start_date: start.startOf("day").format("YYYY-MM-DD"),
    trip_end_date: end.startOf("day").format("YYYY-MM-DD"),
  };
}
